import type { DriveStep } from 'driver.js';

export const customerNotificationsTourId = 'customer:notifications';

export const customerNotificationsSteps: DriveStep[] = [
  {
    element: '[data-tour="customer:nav-notifications"]',
    popover: {
      title: 'Уведомления',
      description:
        'Раздел уведомлений. Бейдж показывает количество непрочитанных сообщений.',
    },
  },
  {
    element: '[data-tour="customer:notifications-list"]',
    popover: {
      title: 'Список уведомлений',
      description:
        'Все уведомления о ваших заказах: создание, отправка, приёмка, готовность к выдаче. Нажмите на уведомление, чтобы отметить как прочитанное.',
    },
  },
  {
    element: '[data-tour="customer:help-btn"]',
    popover: {
      title: 'Помощь',
      description: 'Кнопка помощи.',
    },
  },
];
